import { render, staticRenderFns } from "./Userinfo.vue?vue&type=template&id=4406f3bc&scoped=true"
import script from "./Userinfo.vue?vue&type=script&lang=js"
export * from "./Userinfo.vue?vue&type=script&lang=js"
import style0 from "./Userinfo.vue?vue&type=style&index=0&id=4406f3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406f3bc",
  null
  
)

export default component.exports